function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 394 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 1V0h394v24C376 8 357 1 338 1c-20 0-84 23-159 23-75.5-.5-118-6-179-23z",
    fill: props.color || 'black'
  }));
}
export default SvgHeaderShape;